import { render, staticRenderFns } from "./NavigationDrawerContent.vue?vue&type=template&id=778fd2a7&"
import script from "./NavigationDrawerContent.vue?vue&type=script&lang=ts&"
export * from "./NavigationDrawerContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports